import http from './request'

const doPost = (url, params) => {
  return new Promise((resolve, reject) => {
    // console.log(params)
    http.post(url, params).then(res => {
      var data = res.data
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
}
const doGet = (url, params) => {
  return new Promise((resolve, reject) => {
    http.get(url, params).then(res => {
      var data = res.data
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
}

export default async (url = '', data = {}, type = 'POST') => {
  if (type === 'GET') {
    return doGet(url, data)
  } else if (type === 'POST') {
    return doPost(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/http/fetch.js